const config = [
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'sort', reducerName: 'sort' },
];

export const getContactsList = (state) => {
  const contactsList = {};

  config.forEach(({ propName, reducerName }) => {
    contactsList[propName] = state?.contactsList?.[reducerName];
  });

  return contactsList;
};
